import React from 'react';
import classNames from 'classnames';

export interface PrimaryLinkProps {
  children?: React.ReactNode | string;
  className?: string;
  href?: string;
  id?: string;
  size: 'slim' | 'medium' | 'big';
}

const PrimaryLink = ({ children, className, id, size, href }: PrimaryLinkProps): JSX.Element => {
  const primaryLinkClasses = classNames(
    className,
    'usa-footer__primary-content',
    'desktop:grid-col-auto',
    { 'mobile-lg:grid-col-6': size === 'slim' },
    { 'mobile-lg:grid-col-4': size === 'medium' },
  );

  return size === 'big' ? (
    <h4 id={id} className={classNames(className, 'usa-footer__primary-link')}>
      {children}
    </h4>
  ) : (
    <li className={primaryLinkClasses}>
      <a id={id} className="usa-footer__primary-link" href={href}>
        {children}
      </a>
    </li>
  );
};

export default PrimaryLink;
